export const VECTOR_TILE_FEATURE_PROPERTY = 'vectorTileFeature';

export default {
  VECTOR_TILE_FEATURE_PROPERTY,
};
